import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "../LandingNav";
import { LEGAL_DOCS } from "../../data/legalContent";

export function SiteFooter() {
  return (
    <footer className="border-t border-white/[0.06] px-5 sm:px-8 py-12 pb-28 lg:pb-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <BrandMark />
            <p className="text-xs text-[#4F627B] mt-4 leading-relaxed max-w-xs">
              An educational wellness program by Perfectore Corp. For educational purposes — not a substitute for medical advice.
            </p>
          </div>

          <div>
            <div className="bps-eyebrow text-[#22D3EE] mb-3">Trust Center</div>
            <ul className="space-y-2.5">
              {["privacy-policy", "terms-of-use", "medical-disclaimer", "participant-agreement", "freedom-promise"].map((s) => (
                <li key={s}>
                  <Link to={`/trust-center/${s}`} data-testid={`footer-link-${s}`} className="text-sm text-[#9AAEC6] hover:text-[#22D3EE] transition-colors">
                    {LEGAL_DOCS[s].title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="bps-eyebrow text-[#22D3EE] mb-3">Policies</div>
            <ul className="space-y-2.5">
              {["shipping-returns", "cookie-policy"].map((s) => (
                <li key={s}>
                  <Link to={`/trust-center/${s}`} data-testid={`footer-link-${s}`} className="text-sm text-[#9AAEC6] hover:text-[#22D3EE] transition-colors">
                    {LEGAL_DOCS[s].title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/trust-center" data-testid="footer-link-trust-center" className="text-sm text-[#22D3EE] hover:underline">
                  All policies →
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="bps-eyebrow text-[#22D3EE] mb-3">Help</div>
            <ul className="space-y-2.5">
              {["contact-us", "faq", "support-center", "accessibility"].map((s) => (
                <li key={s}>
                  <Link to={`/trust-center/${s}`} data-testid={`footer-link-${s}`} className="text-sm text-[#9AAEC6] hover:text-[#22D3EE] transition-colors">
                    {LEGAL_DOCS[s].title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] mt-10 pt-6 text-xs text-[#4F627B] leading-relaxed">
          <p>© {new Date().getFullYear()} Perfectore Corp. All Rights Reserved. Freedom From Back Pain™, Back Pain Transformer™, Freedom Promise™, and Perfectore™ are the intellectual property of Perfectore Corp.</p>
          <p className="mt-2">The information provided is for educational and informational purposes only. It is not medical advice and is not intended to diagnose, treat, cure, or prevent any disease. Always consult a qualified healthcare professional. Use of this website constitutes acceptance of our <Link to="/trust-center/terms-of-use" className="text-[#7C8FA8] hover:text-[#22D3EE]">Terms of Use</Link>, <Link to="/trust-center/privacy-policy" className="text-[#7C8FA8] hover:text-[#22D3EE]">Privacy Policy</Link>, <Link to="/trust-center/medical-disclaimer" className="text-[#7C8FA8] hover:text-[#22D3EE]">Medical Disclaimer</Link>, and <Link to="/trust-center/participant-agreement" className="text-[#7C8FA8] hover:text-[#22D3EE]">Participant Agreement</Link>.</p>
        </div>
      </div>
    </footer>
  );
}
